import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin( SplitText );
gsap.registerPlugin( CustomEase );

export function useSplitText ( elRef, options = {
  type: 'chars',
  splitClass: 'inline-block',
} ) {
  let splitInstance = null;

  const animate = ( gsapOptions = {} ) => {
    if ( !elRef.value ) return;

    splitInstance?.revert();

    splitInstance = new SplitText( elRef.value, {
      type: options.type || 'chars',
      lineClass: options.splitClass || 'inline-block',
      wordClass: options.splitClass || 'inline-block',
      charClass: options.splitClass || 'inline-block',
    } );

    // 過濾掉 data-static 的元素（如斷行 br）
    const targets = splitInstance.chars.filter(
      el => !el.hasAttribute( 'data-static' )
    );

    gsap.from( targets, {
      yPercent: 100,
      opacity: 0.5,
      duration: 0.8,
      stagger: 0.05,
      ease: CustomEase.create( "custom", "M0,0 C0.272,0 0.41,0.692 0.442,0.817 0.494,1.022 0.744,1 1,1 " ),
      ...gsapOptions,

      // 自動 revert() 在動畫完成時
      onComplete: () => {
        splitInstance?.revert();
        splitInstance = null;
      },
    } );
  };

  const revert = () => {
    splitInstance?.revert();
    splitInstance = null;
  };

  onBeforeUnmount( revert );

  return {
    animate,
    revert,
  };
}
